export class AnonymousConsumer {
  constructor(public pk_consumer: string, public nation: string) {}
}
